import { render, staticRenderFns } from "./ResellerLogin.vue?vue&type=template&id=6bf3eb7e&"
import script from "./ResellerLogin.vue?vue&type=script&lang=js&"
export * from "./ResellerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports